import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import './ViewProfile.css';
import BusinessSidebar from "../../BusinessSidebar";
import Header from "../../BusinessHeaderAfterLogin";
import Footer from "../../BusinessFooterAfterLogin";

import { Link, useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import API from '../../../Utils/Api';
import loader from '../../../assests/loader.gif';

import { validatebusinessprofile } from '../../../Utils/validate';

import Multiselect from "multiselect-react-dropdown";
import { gettoastwarning, gettoastsuccess } from '../../../Utils/Common';
import Editor from 'react-simple-wysiwyg';


const ViewProfile = () => {

    const navigate = useNavigate();

    const [errors, setErrors] = useState({});

    const [loading, setLoading] = useState(true);

    const [inputs, setInputs] = useState({ business_name: '', email: '', contact_number: '', business_status: '', address: '', business_description: '', pincode: '', state: '', city: '', town: '', category_id: '', profile_per: 0 });

    const [state, setState] = useState([]);
    const [city, setCity] = useState([]);
    const [town, setTown] = useState([]);

    const [category, setCategory] = useState([]);


    const [hoursofoperation, setHoursofoperation] = useState([{
        "id": 0,
        "user_id": 0,
        "business_id": 0,
        "day": "sun",
        "start_time": "",
        "end_time": ""
    },
    {
        "id": 0,
        "user_id": 0,
        "business_id": 0,
        "day": "mon",
        "start_time": "",
        "end_time": ""
    },
    {
        "id": 0,
        "user_id": 0,
        "business_id": 0,
        "day": "tue",
        "start_time": "",
        "end_time": ""
    },
    {
        "id": 0,
        "user_id": 0,
        "business_id": 0,
        "day": "wed",
        "start_time": "",
        "end_time": ""
    },
    {
        "id": 0,
        "user_id": 0,
        "business_id": 0,
        "day": "thu",
        "start_time": "",
        "end_time": ""
    },
    {
        "id": 0,
        "user_id": 0,
        "business_id": 0,
        "day": "fri",
        "start_time": "",
        "end_time": ""
    },
    {
        "id": 0,
        "user_id": 0,
        "business_id": 0,
        "day": "sat",
        "start_time": "",
        "end_time": ""
    }]);


    useEffect(() => {
        document.title = `View Business | Local Bells`;
        document.getElementById('bodywrap').className = 'busieditbusi';
        /* Start get profile */
        let formData1 = new FormData();
        formData1.append(`business_id`, localStorage.getItem("business_id"));
        API.post('get_business_detail', formData1)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {
                } else {
                    setInputs({
                        business_name: response.data.data.business_name,
                        email: response.data.data.email,
                        contact_number: response.data.data.business_contact_number,
                        business_status: response.data.data.business_status,
                        address: response.data.data.address,
                        business_description: response.data.data.description,
                        pincode: response.data.data.pincode,
                        state: response.data.data.state,
                        city: response.data.data.city,
                        town: response.data.data.town,
                        profile_per: response.data.data.profile_per
                    });

                    const ids = response.data.data.categories.map((cat) => cat.id);
                    setInputs(prev => ({ ...prev, category_id: ids }));

                    getCitySel(response.data.data.state);
                    getTownSel(response.data.data.city);

                    if (response?.data?.data?.hoursOfOperation?.length > 0) {
                        setHoursofoperation(response.data.data.hoursOfOperation);
                    }

                    if (response.data?.data?.profile?.length > 0) {
                        const formattedData = response.data.data.profile.map(item => ({
                            id: item.id,
                            file: '',
                            url: item.name,
                        }));
                        // Append to existing list
                        setImages(formattedData);
                    }
                }
            }).catch(error => {
                setLoading(false);
            });
        /* End get profile */

        API.post('get_state')
            .then(response => {
                setState(response.data.data);
            });


        API.post('get_categories')
            .then(response => {

                if (response.data.status === true) {
                    setCategory(response.data.data);
                } else {

                }
            }).catch(error => {

            });

    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);
    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    const [images, setImages] = useState([]);



    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validatebusinessprofile(inputs, hoursofoperation, images);
        setErrors(validationErrors);

        const generalErrors = Object.keys(validationErrors).filter(
            key => !key.startsWith('hour_')
        );
        const hasGeneralError = generalErrors.length > 0;

        const hourErrorsValid = Object.keys(validationErrors)
            .filter(key => key.startsWith('hour_'))
            .every(key => Object.keys(validationErrors[key]).length === 0);

        const noErrors = !hasGeneralError && hourErrorsValid;

        if (noErrors) {
            setLoading(true);

            let formData = new FormData();
            Object.keys(inputs).forEach((key) => {
                if (key === 'category_id') {
                    formData.append('categories', inputs.category_id.join(','));
                } else {
                    formData.append(key, inputs[key]);
                }
            });
            formData.append('hours_of_operation', JSON.stringify(hoursofoperation));

            images.forEach((item, index) => {
                if (item.file) {
                    formData.append(`profile[]`, item.file);
                }
            });
            formData.append(`business_id`, localStorage.getItem("business_id"));
            API.post('update_business_detail', formData)
                .then(response => {
                    if (response.data.status === false) {
                        setLoading(false);
                        gettoastwarning(response.data.message, '');
                    } else {
                        setLoading(false);
                        gettoastsuccess(response.data.message, '/business/my-deal');
                    }
                }).catch(error => {
                    setLoading(false);
                    gettoastwarning("Something went wrong. Please try again later.", '');
                    //setError("Something went wrong. Please try again later.");
                });
        }
    };

    const getCitySel = (state_id) => {
        let formData = new FormData();
        formData.append('state_id', state_id);
        API.post('get_city', formData)
            .then(response => {

                if (response.data.status === true) {
                    setCity(response.data.data);
                } else {


                }
            }).catch(error => {

            });

    }

    const getTownSel = (city_id) => {
        let formData = new FormData();
        formData.append('city_id', city_id);
        API.post('get_town', formData)
            .then(response => {

                if (response.data.status === true) {
                    setTown(response.data.data);
                } else {


                }
            }).catch(error => {

            });
    }



    const getCity = (event) => {
        event.preventDefault();
        setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));

        setTown([]);

        var st = 'city';
        var st_val = '';
        setInputs(inputs => ({ ...inputs, [st]: st_val }));

        var ct = 'town';
        var ct_val = '';
        setInputs(inputs => ({ ...inputs, [ct]: ct_val }));

        var ctt = 'category_id';
        var ctt_val = '';
        setInputs(inputs => ({ ...inputs, [ctt]: ctt_val }));

        let formData = new FormData();
        formData.append('state_id', event.target.value);
        API.post('get_city', formData)
            .then(response => {

                if (response.data.status === true) {
                    setCity(response.data.data);
                } else {


                }
            }).catch(error => {

            });

    }

    const getTown = (event) => {
        event.preventDefault();
        setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
        setTown([]);

        var ct = 'town';
        var ct_val = '';
        setInputs(inputs => ({ ...inputs, [ct]: ct_val }));

        var ctt = 'category_id';
        var ctt_val = '';
        setInputs(inputs => ({ ...inputs, [ctt]: ctt_val }));
        let formData = new FormData();
        formData.append('city_id', event.target.value);
        API.post('get_town', formData)
            .then(response => {

                if (response.data.status === true) {
                    setTown(response.data.data);
                } else {


                }
            }).catch(error => {

            });
    }
    const getCat = (event) => {
        event.preventDefault();
        setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
        get_town_picode(event.target.value);
    }
    const get_town_picode = (id) => {
        let formData = new FormData();
        formData.append('town_id', id);
        API.post('get_town_pincode', formData)
            .then(response => {

                if (response.data.status === true) {
                    if (response.data.data.city_id !== '') {
                        var pincode_label = 'pincode';
                        var pincode_val = response.data.data.pincode;
                        setInputs(inputs => ({ ...inputs, [pincode_label]: pincode_val }));
                    }
                } else {

                }
            }).catch(error => {

            });
    }

    const getpicode_town = () => {
        if (inputs.pincode !== '') {
            let formData = new FormData();
            formData.append('pin_code', inputs.pincode);
            API.post('get_pincode_town', formData)
                .then(response => {

                    if (response.data.status === true) {
                        if (response.data.data.city_id !== '' && response.data.data.city_id !== '') {
                            setCity(response.data.data.city);
                            setTown(response.data.data.town);
                            var state_label = 'state';
                            var state = response.data.data.state_id;
                            setInputs(inputs => ({ ...inputs, [state_label]: state }));

                            var city_label = 'city';
                            var city = response.data.data.city_id;
                            setInputs(inputs => ({ ...inputs, [city_label]: city }));

                            var town_label = 'town';
                            var town = response.data.data.town_id;
                            setInputs(inputs => ({ ...inputs, [town_label]: town }));
                        }
                    } else {

                    }
                }).catch(error => {

                });
        }
    }
    /* Start Value set */
    const handleInputChange = (event) => {
        event.persist();
        setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
    }
    const handleInputChangeMo = (event) => {
        event.persist();
        const { name, value } = event.target;

        // Allow only numbers (0–9)
        const regex = /^[0-9]*$/;

        if (regex.test(value)) {
            setInputs(inputs => ({ ...inputs, [name]: value }));
        }
    }
    const handleInputChangeSpe = (event) => {
        event.persist();
        const { name, value } = event.target;

        // Allow only letters, numbers, spaces, and basic punctuation if needed
        const regex = /^[a-zA-Z0-9\s]*$/;

        if (regex.test(value)) {
            setInputs(inputs => ({ ...inputs, [name]: value }));
        }
    }
    /* End Value set */
    const handleCategorySelect = (selectedList) => {
        const ids = selectedList.map(lang => lang.id);
        setInputs(prev => ({ ...prev, category_id: ids }));
        setTimeout(() => {
            document.querySelector(".custom-multiselect input")?.blur();
        }, 50);
    };

    const handleCategoryRemove = (selectedList) => {
        const ids = selectedList.map(lang => lang.id);
        setInputs(prev => ({ ...prev, category_id: ids }));
    };

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <BusinessSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <div className='white-box business-form'>

                                    <Row className='mb-3'>
                                        <div className="d-flex align-items-start justify-content-end gap-3">
                                            <Link to="#" onClick={() => navigate(-1)} className='cross-up'>
                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid crosy" alt="wp" />
                                            </Link>
                                        </div>
                                        <Col md={12} lg={12} xl={5}>
                                            <h3>View business Profile</h3>
                                        </Col>
                                        {/* <Col md={12} lg={12} xl={7}>
                                            <div className='bf-right'>
                                                <div>
                                                    <ProgressBar value={inputs.profile_per} />
                                                    <h6 className='fw-600 text-uppercase'>{inputs.profile_per}% Competed</h6>
                                                </div>
                                                <Link to="/business/new-deal" className='add-link'>+ Add Discount Deals</Link>
                                            </div>
                                        </Col> */}
                                    </Row>
                                    <Form onSubmit={handleSubmit}>
                                        <Row>
                                            <Col md={12} lg={12} xl={5}>

                                                <div className="row">
                                                    {/* <div className="col-md-4 mb-3">
                                                        <label
                                                            className="anb-upload"
                                                            style={{ cursor: images.length < 5 ? 'pointer' : 'not-allowed' }}
                                                        >
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                multiple
                                                                onChange={handleImageChange}
                                                                style={{ display: 'none' }}
                                                                disabled={images.length >= 5}
                                                            />
                                                            <span className="text-danger text-center">
                                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/upload.webp'} className="img-fluid" alt="upload" />
                                                                <p>Up to 5 images</p>
                                                                <h6><span className='fw-600'>192 X 108</span> px</h6>
                                                            </span>
                                                        </label>

                                                    </div> */}
                                                    {images.map((img, index) => (
                                                        <div className="col-md-4 mb-3">
                                                            <div className="position-relative anb-upl-img">
                                                                <img
                                                                    src={img.url}
                                                                    alt="Preview"
                                                                    className="img-fluid rounded"
                                                                />
                                                                {/* <button
                                                                    className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                                                                    onClick={() => handleDelete(index, img.id)}
                                                                >
                                                                    &times;
                                                                </button> */}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                {errors.images && (<p className="text-danger">{errors.images}</p>)}
                                                {/*<Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>First Name</Form.Label>
                                                    <Form.Control type="text" placeholder="First Name" name="first_name" onChange={handleInputChangeSpe} value={inputs.first_name} />
                                                </Form.Group>
                                                {errors.first_name && (<p className="text-danger">{errors.first_name}</p>)}
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>Last Name</Form.Label>
                                                    <Form.Control type="text" placeholder="Last Name" name="last_name" onChange={handleInputChangeSpe} value={inputs.last_name} />
                                                </Form.Group>
                                                {errors.last_name && (<p className="text-danger">{errors.last_name}</p>)}*/}

                                                <Form.Group className="mb-3">
                                                    <Form.Label className=''>Business Name</Form.Label>
                                                    <Form.Control type="text" placeholder="Business Name" name="business_name" onChange={handleInputChangeSpe} value={inputs.business_name} readOnly />
                                                </Form.Group>
                                                {errors.business_name && (<p className="text-danger">{errors.business_name}</p>)}
                                                <Form.Group className="mb-3">
                                                    <Form.Label className=''>Business Email</Form.Label>
                                                    <Form.Control type="text" placeholder="Business Email" value={inputs.email} disabled />
                                                </Form.Group>
                                                {errors.email && (<p className="text-danger">{errors.email}</p>)}
                                                <Form.Label className=''>Contact Number</Form.Label>
                                                <InputGroup className="anb-cont mb-3">

                                                    <Form.Control
                                                        placeholder="Contact No"
                                                        aria-label="cntno"
                                                        aria-describedby="cntno"
                                                        type="text"
                                                        name="contact_number" onChange={handleInputChangeMo} value={inputs.contact_number}
                                                        maxLength={15}
                                                        readOnly
                                                    />
                                                    {/* <InputGroup.Text id="cntno">
                                                        <Link to="/">Verify phone number</Link>
                                                    </InputGroup.Text> */}
                                                </InputGroup>
                                                {errors.contact_number && (<p className="text-danger">{errors.contact_number}</p>)}
                                                <Form.Label className=''>Status of Business</Form.Label>
                                                <Form.Select aria-label="Default select example" name="business_status" onChange={handleInputChange} value={inputs.business_status} disabled>
                                                    <option value="">Status of Business</option>
                                                    <option value="open">Open</option>
                                                    <option value="temporarily">Temporarily Closed</option>
                                                    <option value="permanently">Permanently Closed</option>
                                                    <option value="reopened">Re Opened</option>
                                                </Form.Select>
                                                {errors.business_status && (<p className="text-danger">{errors.business_status}</p>)}

                                                <Form.Group className="mb-3">
                                                    <Form.Label className=''>Business Address</Form.Label>
                                                    <Form.Control as="textarea" rows={4} placeholder='Business Address' name="address" onChange={handleInputChange} value={inputs.address} readOnly />
                                                </Form.Group>
                                                {errors.address && (<p className="text-danger">{errors.address}</p>)}
                                                {/*<Form.Group className="mb-3">
                                                    <Form.Label className=''>Type some description</Form.Label>
                                                    <Form.Control as="textarea" rows={4} placeholder='Business Description' name="business_description" onChange={handleInputChange} value={inputs.business_description} readOnly />
                                                </Form.Group>*/}
                                                <div className='my-3'>
                                                    <Form.Label className=''>Type some description</Form.Label>
                                                    <Editor value={inputs.business_description} style={{ height: '100px' }}/>
                                                    
                                                </div>
                                                {errors.business_description && (<p className="text-danger">{errors.business_description}</p>)}
                                                {/* <h6 className='max-note'>Max 1000 characters</h6> */}

                                            </Col>
                                            <Col md={12} lg={12} xl={7}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className=''>Pin code</Form.Label>
                                                    <Form.Control type="text" placeholder="Pin code" name="pincode" onChange={handleInputChangeMo} onBlur={getpicode_town} value={inputs.pincode} maxLength={6} readOnly />
                                                </Form.Group>
                                                {errors.pincode && (<p className="text-danger">{errors.pincode}</p>)}

                                                <Row>
                                                    <Col md={4}>
                                                        <Form.Label className=''>State</Form.Label>
                                                        <Form.Select aria-label="Default select example" name="state" onChange={getCity} value={inputs.state} disabled>
                                                            <option value="">State</option>
                                                            {state && state.map((val, index) => {
                                                                return (
                                                                    <option value={val.id}>{val.name}</option>
                                                                )
                                                            })}
                                                        </Form.Select>
                                                        {errors.state && (<p className="text-danger">{errors.state}</p>)}
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Label className=''>City</Form.Label>
                                                        <Form.Select aria-label="Default select example" name="city" onChange={getTown} value={inputs.city} disabled>
                                                            <option value="">City</option>
                                                            {city && city.map((val, index) => {
                                                                return (
                                                                    <option value={val.id}>{val.name}</option>
                                                                )
                                                            })}
                                                        </Form.Select>
                                                        {errors.city && (<p className="text-danger">{errors.city}</p>)}
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Label className=''>Locality</Form.Label>
                                                        <Form.Select aria-label="Default select example" name="town" onChange={getCat} value={inputs.town} disabled>
                                                            <option value="">Locality</option>
                                                            {town && town.map((val, index) => {
                                                                return (
                                                                    <option value={val.id}>{val.name}</option>
                                                                )
                                                            })}
                                                        </Form.Select>
                                                        {errors.town && (<p className="text-danger">{errors.town}</p>)}
                                                    </Col>
                                                </Row>
                                                <Form.Label className=''>Category</Form.Label>
                                                <div className="position-relative">
                                                    <div className="multi-drop-box">
                                                        X
                                                    </div>
                                                    <Multiselect
                                                        options={category}
                                                        selectedValues={category.filter(lang => inputs.category_id.includes(lang.id))}
                                                        onSelect={handleCategorySelect}
                                                        onRemove={handleCategoryRemove}
                                                        placeholder="Select Category"
                                                        className="custom-multiselect"
                                                        displayValue="name"
                                                        showArrow={false}
                                                        disable
                                                    />
                                                </div>
                                                {errors.category_id && (<p className="text-danger">{errors.category_id}</p>)}

                                                <Row>
                                                    <Col md={12}>
                                                        <h6>Hours Of Operation</h6>
                                                    </Col>
                                                </Row>

                                                {hoursofoperation.map((day, index) => {

                                                    const updateTime = (field, value) => {
                                                        setHoursofoperation(prev =>
                                                            prev.map((item, i) => {
                                                                if (i !== index) return item;

                                                                // If Closed selected → both Closed
                                                                if (value === "Closed") {
                                                                    return { ...item, start_time: "Closed", end_time: "Closed" };
                                                                }

                                                                // If START TIME changed from Closed to a normal value → clear end time
                                                                if (field === "start_time" && item.end_time === "Closed") {
                                                                    return { ...item, start_time: value, end_time: "" };
                                                                }

                                                                // Otherwise update normally
                                                                return { ...item, [field]: value };
                                                            })
                                                        );
                                                    };

                                                    return (
                                                        <Row key={index}>
                                                            <Col className="pt-3 col-2">
                                                                <div className="text-center pb-3 pb-md-0">
                                                                    {day.day.toUpperCase()}
                                                                </div>
                                                            </Col>

                                                            {/* Start Time */}
                                                            <Col className="col-5">
                                                                <Form.Select
                                                                    aria-label="Start time"
                                                                    value={day.start_time}
                                                                    onChange={(e) => updateTime("start_time", e.target.value)}
                                                                    disabled>
                                                                    <option value="">Select from time</option>
                                                                    <option value="Closed">Closed</option>
                                                                    <option value="00:00">12:00 AM</option>
                                                                      <option value="01:00">1:00 AM</option>
                                                                      <option value="02:00">2:00 AM</option>
                                                                      <option value="03:00">3:00 AM</option>
                                                                      <option value="04:00">4:00 AM</option>
                                                                      <option value="05:00">5:00 AM</option>
                                                                      <option value="06:00">6:00 AM</option>
                                                                      <option value="07:00">7:00 AM</option>
                                                                      <option value="08:00">8:00 AM</option>
                                                                      <option value="09:00">9:00 AM</option>
                                                                      <option value="10:00">10:00 AM</option>
                                                                      <option value="11:00">11:00 AM</option>
                                                                      <option value="12:00">12:00 PM</option>
                                                                      <option value="13:00">1:00 PM</option>
                                                                      <option value="14:00">2:00 PM</option>
                                                                      <option value="15:00">3:00 PM</option>
                                                                      <option value="16:00">4:00 PM</option>
                                                                      <option value="17:00">5:00 PM</option>
                                                                      <option value="18:00">6:00 PM</option>
                                                                      <option value="19:00">7:00 PM</option>
                                                                      <option value="20:00">8:00 PM</option>
                                                                      <option value="21:00">9:00 PM</option>
                                                                      <option value="22:00">10:00 PM</option>
                                                                      <option value="23:00">11:00 PM</option>
                                                                </Form.Select>

                                                                {errors[`hour_${index}`]?.start_time && (
                                                                    <p className="text-danger">{errors[`hour_${index}`].start_time}</p>
                                                                )}
                                                            </Col>

                                                            {/* End Time → Hidden if Start Time = Closed */}
                                                            {day.start_time !== "Closed" && (
                                                                <Col className="col-5">
                                                                    <Form.Select
                                                                        aria-label="End time"
                                                                        value={day.end_time}
                                                                        onChange={(e) => updateTime("end_time", e.target.value)}
                                                                        disabled>
                                                                        <option value="">Select to time</option>
                                                                        <option value="Closed">Closed</option>
                                                                       <option value="00:00">12:00 AM</option>
                                                                          <option value="01:00">1:00 AM</option>
                                                                          <option value="02:00">2:00 AM</option>
                                                                          <option value="03:00">3:00 AM</option>
                                                                          <option value="04:00">4:00 AM</option>
                                                                          <option value="05:00">5:00 AM</option>
                                                                          <option value="06:00">6:00 AM</option>
                                                                          <option value="07:00">7:00 AM</option>
                                                                          <option value="08:00">8:00 AM</option>
                                                                          <option value="09:00">9:00 AM</option>
                                                                          <option value="10:00">10:00 AM</option>
                                                                          <option value="11:00">11:00 AM</option>
                                                                          <option value="12:00">12:00 PM</option>
                                                                          <option value="13:00">1:00 PM</option>
                                                                          <option value="14:00">2:00 PM</option>
                                                                          <option value="15:00">3:00 PM</option>
                                                                          <option value="16:00">4:00 PM</option>
                                                                          <option value="17:00">5:00 PM</option>
                                                                          <option value="18:00">6:00 PM</option>
                                                                          <option value="19:00">7:00 PM</option>
                                                                          <option value="20:00">8:00 PM</option>
                                                                          <option value="21:00">9:00 PM</option>
                                                                          <option value="22:00">10:00 PM</option>
                                                                          <option value="23:00">11:00 PM</option>
                                                                    </Form.Select>

                                                                    {errors[`hour_${index}`]?.end_time && (
                                                                        <p className="text-danger">{errors[`hour_${index}`].end_time}</p>
                                                                    )}
                                                                </Col>
                                                            )}
                                                        </Row>
                                                    );
                                                })}




                                                {/* <div className='yellow-note'>
                                                    <h6>Tag upto 10 categories. Your business will be shown in search when users search for business with one of your selected categories</h6>
                                                </div> */}


                                                {/* <Button variant="primary" type="submit" className='orange-btn'>
                                                    <h6>Save</h6>
                                                </Button> */}
                                            </Col>
                                        </Row>
                                    </Form>
                                </div>
                                <div className='footer-org footer'>
                                    <Footer />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {loading && (
                <div className="loadingClass">
                    <img src={loader} alt="loader" />
                </div>
            )}
        </>
    )
}

export default ViewProfile;


